import useAxios from "../hooks/useAxios";

const baseURL = process.env.REACT_APP_BASE_URL;


let url = "/contact-us";
let sendContactMessageUrl = "/send-contact-message";

const useContactUsAPI = () => {
  const { axiosInstance } = useAxios();

  const sendContactMessage = async (data: any) => {
    let response = await axiosInstance.post(baseURL + `${url}${sendContactMessageUrl}`, data);
    return response;
  };

  return {
    sendContactMessage,
  };
};

export default useContactUsAPI;